(() => {
  const cartUrl = theme.routes.cart;
  let releasedForm = null;

  const fetchCartItems = async () => {
    const response = await fetch(`${cartUrl}.js`, { cache: 'no-store' });
    const cart = await response.json();

    return cart.items;
  };

  const containsProduct = (items, productId) => items
    .some((item) => String(item.product_id) === productId);

  const emptyCart = () => fetch(`${cartUrl}/clear.js`, { method: 'POST' });

  const releaseAddToCartForm = (form, submitter) => {
    releasedForm = form;
    form.requestSubmit(submitter);
  };

  document.addEventListener('submit', async (evt) => {
    const form = evt.target;
    if (!form.classList.contains('js-product-form')) return;

    if (form === releasedForm) {
      releasedForm = null;
      return;
    }

    evt.preventDefault();
    evt.stopPropagation();

    const items = await fetchCartItems();

    if (containsProduct(items, form.dataset.refillProductId)) return;
    await emptyCart();

    releaseAddToCartForm(form, evt.submitter);
  }, true);
})();
